import { render, staticRenderFns } from "./InfoTogue.vue?vue&type=template&id=508e3122&scoped=true&"
import script from "./InfoTogue.vue?vue&type=script&lang=js&"
export * from "./InfoTogue.vue?vue&type=script&lang=js&"
import style0 from "./InfoTogue.vue?vue&type=style&index=0&id=508e3122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e3122",
  null
  
)

export default component.exports